import { CORE_API } from 'config';
import { SharedEnaraNodeClient } from 'node-api/common/SharedEnaraNodeClient';
import { GetClinicResponse } from './types';

export default class ClinicsServiceClient extends SharedEnaraNodeClient {
  constructor() {
    super(CORE_API.url, false);
  }

  public async getClinic(clinicId: number) {
    const { data } = await this.axiosClient.get<GetClinicResponse>(`/v3/clinics/${clinicId}`);
    return data.clinic;
  }
}
